import React from 'react';
import { OverlayTrigger, Tooltip, OverlayTriggerProps } from 'react-bootstrap';

export interface LomavisMoreInfoProps {
  text: string | React.ReactNode;
  placement?: OverlayTriggerProps['placement'];
  showDelay?: number;
  hideDelay?: number;
  iconClassName?: string;
  wrapperClassName?: string;
}

/**
 * LomavisMoreInfo
 *
 * A tiny info icon that shows a tooltip with helper text.
 * Styling matches existing inline "more info" tooltips in forms.
 */
export const LomavisMoreInfo: React.FC<LomavisMoreInfoProps> = ({
  text,
  placement = 'top',
  showDelay = 100,
  hideDelay = 100,
  iconClassName = 'fa-duotone fa-circle-info cursor-pointer ms-1',
  wrapperClassName = 'd-inline-flex align-items-center',
}) => {
  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: showDelay, hide: hideDelay }}
      overlay={
        <Tooltip>
          <span style={{ display: 'block', textAlign: 'left' }} className="text-muted">
            {text}
          </span>
        </Tooltip>
      }
    >
      <span className={wrapperClassName}>
        <i className={iconClassName} aria-label="More information"></i>
      </span>
    </OverlayTrigger>
  );
};

export default LomavisMoreInfo;
